import { css } from "@linaria/core";

import { pm2Boundaries } from "@pm2/design-tokens";

export const wrapperCls = css`
  margin-right: ${pm2Boundaries.container.offsetRight({ scale: -1 })};
  margin-left: ${pm2Boundaries.container.offsetLeft({ scale: -1 })};
`;
